export default "__VITE_ASSET__ES0nz9Tf__"